import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, CheckCircle, ShoppingBag } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import PurchaseRecCard from "@/components/PurchaseRecCard";

export default function ProjectShopPage() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const navigate = useNavigate();

  const load = async () => {
    const r = await api.get(`/projects/${id}`);
    setProject(r.data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [id]);

  if (!project) return null;
  const items = (project.materials || []).filter((m) => m.status === "need_to_buy");

  const markBought = async (mId) => {
    await api.patch(`/projects/materials/${mId}`, { status: "bought" });
    toast.success("Bought ✓");
    load();
  };

  return (
    <div className="min-h-screen pb-32" data-testid="project-shop-page">
      <header className="px-5 pt-6 pb-3 max-w-md mx-auto w-full">
        <button onClick={() => navigate(-1)} data-testid="shop-back-btn" className="flex items-center gap-1 text-timber-700 font-bold">
          <ArrowLeft size={18} weight="bold" /> Back
        </button>
        <div className="flex items-center gap-2 mt-3">
          <ShoppingBag size={28} weight="duotone" className="text-masking" />
          <h1 className="font-heading text-2xl font-bold">Shop list</h1>
        </div>
        <p className="text-sm text-timber-700 mt-1">{project.title}</p>
      </header>

      <main className="px-5 max-w-md mx-auto w-full space-y-3">
        {items.length === 0 ? (
          <div className="tactile-card p-6 text-center">
            <CheckCircle size={40} weight="duotone" className="mx-auto text-ok" />
            <p className="text-timber-900 font-bold mt-2">All materials ready</p>
            <p className="text-sm text-timber-700 mt-1">This project is ready to finish.</p>
          </div>
        ) : items.map((m) => (
          <div key={m.id} data-testid={`shop-row-${m.id}`} className="tactile-card p-4">
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1 min-w-0">
                <p className="font-heading text-lg font-bold text-timber-900">
                  {m.name}{m.quantity && <span className="text-timber-500 font-normal text-base"> · {m.quantity}</span>}
                </p>
                {m.purchase_suggestion?.category && (
                  <p className="text-[11px] text-timber-500 font-mono uppercase tracking-wider mt-0.5">
                    {m.purchase_suggestion.category}
                  </p>
                )}
              </div>
              <button
                data-testid={`mark-bought-${m.id}`}
                onClick={() => markBought(m.id)}
                className="bg-ok text-white font-bold rounded-xl px-4 py-2 flex flex-col items-center min-h-[64px] btn-press shadow-tactile"
              >
                <CheckCircle size={20} weight="fill" />
                <span className="text-xs mt-0.5">Bought</span>
              </button>
            </div>
            {m.purchase_suggestion && (
              <div className="mt-3">
                <PurchaseRecCard suggestion={m.purchase_suggestion} />
              </div>
            )}
          </div>
        ))}
      </main>
    </div>
  );
}
